/**
 * AudioUploaderDialog — Modal "Subir Archivo de Audio"
 *
 * Extraído de App.js líneas 8241-8273 durante la Ola E del refactor 2026-02.
 * Wrapper delgado sobre el componente AudioUploader existente.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { AudioUploader } from './AudioUploader';

export const AudioUploaderDialog = ({
  isOpen,
  onOpenChange,
  playlistId,
  onUploadSuccess,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-slate-800 border-slate-700 text-white w-[95vw] max-w-2xl overflow-hidden"
        data-testid="audio-uploader-dialog"
      >
        <DialogHeader>
          <DialogTitle className="text-xl text-white">Subir Archivo de Audio</DialogTitle>
          <p className="text-slate-400 text-sm mt-2">
            Sube un archivo MP3 o M4A para agregarlo a las peticiones del evento
          </p>
        </DialogHeader>

        <div className="overflow-hidden">
          <AudioUploader
            playlistId={playlistId}
            onUploadSuccess={onUploadSuccess}
            onClose={() => onOpenChange(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AudioUploaderDialog;
